import { render, staticRenderFns } from "./button-global-player-login.vue?vue&type=template&id=751a9ea6&"
import script from "./button-global-player-login.js?vue&type=script&lang=js&"
export * from "./button-global-player-login.js?vue&type=script&lang=js&"
import style0 from "./button-global-player-login.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports